import { render, staticRenderFns } from "./InterestInstagram.vue?vue&type=template&id=256bd6e8&scoped=true&"
import script from "./InterestInstagram.vue?vue&type=script&lang=js&"
export * from "./InterestInstagram.vue?vue&type=script&lang=js&"
import style0 from "./InterestInstagram.vue?vue&type=style&index=0&id=256bd6e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256bd6e8",
  null
  
)

export default component.exports